<template>
  <div class="arrow  arrow-prev" @click="notifyPrev">
    <svg width="45px" height="45px" viewBox="0 0 45 45" version="1.1" xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>Group</title>
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group">
          <circle id="Oval" fill="#FFFFFF" cx="22.5" cy="22.5" r="22.5"></circle>
          <polyline id="Rectangle-Copy-5" stroke="#005073" stroke-width="2"
            transform="translate(18.671573, 22.500000) rotate(-45.000000) translate(-18.671573, -22.500000) "
            points="26.1715729 15 26.1715729 30 11.1715729 30"></polyline>
        </g>
      </g>
    </svg>
  </div>
</template>
<script>
export default {
  name: 'ArrowPrev',
  methods: {
    notifyPrev () {
      this.$emit('prev')
    }
  }
}
</script>
